import mutations from './documentHistory.mutations'
import actions from './documentHistory.actions'
import getters from './documentHistory.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
